import React from 'react';

import PropTypes from 'prop-types';
import { MdContentPaste, MdSync, MdTrackChanges } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { openSyncModal, pendingRequestsCountSel } from '@offline';
import { isScoutbookRoleSel } from '@shared';
import { Fab } from '@shared/components';
import { hasNewPermissionSel } from '@shared/duck/selectors/general.selectors';
import { newPermissions } from '@shared/newPermissions';

import { ReportFab } from '../../../../../common';
import styles from './ActionFab.less';
import ProgressFab from './ProgressFab';

const { Item, Divider } = Fab;

class ActionFab extends React.PureComponent {
  state = {
    progressFabOpen: false,
    reportFabOpen: false,
  };

  handleShowProgressFab = () => {
    this.setState({ progressFabOpen: true });
  };

  handleShowReportFab = () => {
    this.setState({ reportFabOpen: true });
  };

  handleProgressFabOpenChange = open => {
    this.setState({ progressFabOpen: open });
  };

  handleReportFabOpenChange = open => {
    this.setState({ reportFabOpen: open });
  };

  handleOpenSyncModal = () => {
    this.props.onOpenSyncModal();
  };

  renderRecordAdvancementOption = () => (
    <React.Fragment>
      <Item
        className="Joyride__RosterProgressButton"
        onClick={this.handleShowProgressFab}
      >
        <FormattedMessage id="packRoster.ActionFab.progress" />
      </Item>
      <Divider />
    </React.Fragment>
  );

  render() {
    const {
      selectedItems,
      isOffline,
      visible,
      pendingRequestsCount,
      isScoutbookRole,
      canRecordAdvancement,
    } = this.props;
    const { progressFabOpen, reportFabOpen } = this.state;
    const hasSelectedItems = selectedItems.length > 0;
    const hasPendingRequests = pendingRequestsCount > 0;
    const shouldShowMore = hasSelectedItems || hasPendingRequests;
    return (
      <React.Fragment>
        <ReportFab
          visible={visible && (reportFabOpen || !shouldShowMore)}
          open={reportFabOpen}
          onOpenChange={this.handleReportFabOpenChange}
          isOffline={isOffline}
          showAllUsers={false}
        />
        <ProgressFab
          isScoutbookRole={isScoutbookRole}
          canRecordAdvancement={canRecordAdvancement}
          visible={visible && progressFabOpen}
          open={progressFabOpen}
          selectedItems={selectedItems}
          onOpenChange={this.handleProgressFabOpenChange}
        />
        <Fab
          className="Joyride__RosterActionFab"
          visible={
            visible && shouldShowMore && !progressFabOpen && !reportFabOpen
          }
          content={
            <React.Fragment>
              {hasSelectedItems && this.renderRecordAdvancementOption()}
              {hasPendingRequests && (
                <React.Fragment>
                  <Item
                    id="qa_syncOffline"
                    onClick={this.handleOpenSyncModal}
                    icon={<MdSync />}
                  >
                    <FormattedMessage
                      id={
                        isOffline
                          ? 'packRoster.ActionFab.readyToUpload'
                          : 'packRoster.ActionFab.syncContent'
                      }
                      values={{ count: pendingRequestsCount }}
                    />
                  </Item>
                  <Divider />
                </React.Fragment>
              )}
              <Item
                className="Joyride__RosterReportButton"
                icon={<MdContentPaste />}
                onClick={this.handleShowReportFab}
                disabled={isOffline}
              >
                <FormattedMessage
                  id={`packRoster.ActionFab.${
                    hasSelectedItems ? 'reportSelected' : 'report'
                  }`}
                />
              </Item>
            </React.Fragment>
          }
        >
          <span className={styles.actionTitle}>
            <FormattedMessage id="packRoster.ActionFab.title" />
            <React.Fragment>
              <MdTrackChanges className={styles.icon} />
              <MdContentPaste className={styles.icon} />
            </React.Fragment>
          </span>
        </Fab>
      </React.Fragment>
    );
  }
}

ActionFab.propTypes = {
  visible: PropTypes.bool.isRequired,
  selectedItems: PropTypes.array.isRequired,
  isOffline: PropTypes.bool.isRequired,
  // Provided by Component itself
  pendingRequestsCount: PropTypes.number.isRequired,
  onOpenSyncModal: PropTypes.func.isRequired,
  isScoutbookRole: PropTypes.bool.isRequired,
  canRecordAdvancement: PropTypes.bool.isRequired,
};

const mapState = state => ({
  pendingRequestsCount: pendingRequestsCountSel(state),
  isScoutbookRole: isScoutbookRoleSel(state),
  canRecordAdvancement: hasNewPermissionSel(
    state,
    newPermissions.APPROVE_ADVANCEMENTS,
  ),
});

const mapDispatch = dispatch => ({
  onOpenSyncModal: () => dispatch(openSyncModal()),
});

export default connect(mapState, mapDispatch)(ActionFab);
